// https://josselinbuils.me/blog/stop-using-index-files

import GroupSize from '../BookingGroupSize'
import ChooseProduct from './ChooseProduct'
import ContactDetails from './ContactDetails'
import GroupAndDate from './GroupAndDate'


export { GroupSize, ChooseProduct, ContactDetails, GroupAndDate }
